import { FC } from 'react';
import { TColoredText } from 'mir-utils/time/types';
import { getMessageAndColorForExpirationTime } from '../../time/date-formatter';
import { useTranslation } from '../../i18n';
import { useTime } from '../../providers';
import { LabelTypography } from '../LabelTypography';

/**
 * @summary Компонент, который выводит отформатированную дату.
 *
 * @param date - Время в формате Unix timestamp.
 * @param successStatusDays - Количество дней, больше которого время считается success.
 * @param warningStatusDays - Количество дней, больше которого время считается warning.
 * @param hideRelative - Флаг, отвечающий за скрытие относительной даты.
 *
 * @description Компонент принимает дату (которая ещё не наступила) и определяет,
 * сколько дней до неё осталось. В зависимости от того, насколько близка эта дата,
 * текст будет форматироваться и выделяться цветом согласно логике работы функции
 * getMessageAndColorForExpirationTime.
 *
 */

export const DateLabel: FC<{
  date: Date;
  successStatusDays?: number;
  warningStatusDays?: number;
  hideRelative?: boolean;
}> = ({ date, successStatusDays, warningStatusDays, hideRelative }) => {
  const { t } = useTranslation();

  const now = useTime();

  // Красная когда в прошлом
  // Такое (date -> null || undefined) не должно происходить, но добавим на всякий случай. Очень сложный код фронтенда.
  const [text, color]: readonly [string, TColoredText] =
    date === null
      ? [t('error'), 'error']
      : getMessageAndColorForExpirationTime({
          date,
          now,
          successStatusDays,
          warningStatusDays,
          hideRelative,
        });

  return (
    <LabelTypography text={text} type={color}>
      {text}
    </LabelTypography>
  );
};
